import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import Tracking from '@spotahome/soyuz-tracking';

import debounce from '@spotahome/marketplace-common/src/utils/debounce';

import {
  isFilterChecked,
  getEnabledValue,
  getDisabledValue
} from './utils/prefilters';

import { PREFILTERS_CONFIG } from './constants';

import PreFilterItem from './PreFilterItem';
import PreFiltersSummary from './PreFiltersSummary';

import './PreFilters.scss';

const SCROLL_DEBOUNCE = 500;

const PreFilters = ({ filters, onFiltersUpdate }) => {
  const [prefiltersApplied, setPrefiltersApplied] = useState([]);

  const handlePrefilterClick = filterConfig => () => {
    let newFilterValue;
    let filtersSelected = [...prefiltersApplied];
    if (isFilterChecked(filters, filterConfig.filter, filterConfig.value)) {
      newFilterValue = getDisabledValue(
        filters,
        filterConfig.filter,
        filterConfig.value
      );
      filtersSelected = filtersSelected.filter(
        filter => filter !== filterConfig.id
      );
    } else {
      newFilterValue = getEnabledValue(
        filters,
        filterConfig.filter,
        filterConfig.value
      );
      filtersSelected = [...filtersSelected, filterConfig.id];
    }

    onFiltersUpdate({ [filterConfig.filter]: newFilterValue });
    setPrefiltersApplied(filtersSelected);
  };

  const handleScroll = debounce(() => {
    Tracking.ga.sendEvent('Search', 'prefilter-scroll');
  }, SCROLL_DEBOUNCE);

  return (
    <div className="pre-filters">
      <ul className="pre-filters__list" onScroll={handleScroll}>
        {PREFILTERS_CONFIG.map(filterConfig => (
          <li key={filterConfig.id} className="pre-filters__list-item">
            <PreFilterItem
              id={filterConfig.id}
              onChange={handlePrefilterClick(filterConfig)}
              checked={isFilterChecked(
                filters,
                filterConfig.filter,
                filterConfig.value
              )}
            />
          </li>
        ))}
      </ul>

      {prefiltersApplied.length === 1 ? (
        <PreFiltersSummary
          title={trans(`search.prefilters.${prefiltersApplied[0]}.title.short`)}
        />
      ) : null}
    </div>
  );
};

PreFilters.propTypes = {
  filters: PropTypes.shape({}).isRequired,
  onFiltersUpdate: PropTypes.func.isRequired
};

export default PreFilters;
